import Employee from "@/employee/Employee"
import ValueMod from "@/effects/ValueMod"
import { Personality } from "@/employee/Personality"

export class BouncyPersonality extends Personality {
    id: string = 'bouncy'
    affix: string = 'prefix'

    description(): string {
      return `Bouncy characters love having big breasts full of milk.`
    }

    get constantMods(): { [key: string]: [ValueMod] } {
      return {
        "fullMilkMoodFactor": [new ValueMod(5, 'mul')]
      }
    }

    onUpdate(dt: number, employee: Employee) {
      employee.mood.valueMods["bouncy"] = new ValueMod(10 * employee.milk.fraction, 'add')
      employee.mood.valueMods["bouncy-2"] = new ValueMod(Math.min(employee.milk.value, 10), 'add')
    }
}
